module.exports = __webpack_public_path__ + "img/address.0498e5b8.svg";